import { audienceAllows } from "../audio-listen-panel/audio-audience";

export const driveModeAvailable = () =>
  process.env.REACT_APP_AUDIO_MODE_ENABLED === "true" &&
  process.env.REACT_APP_DRIVE_MODE_ENABLED === "true" &&
  audienceAllows();
